jQuery(document).ready(function($) {

    var module_name = 'image';
});